import { IBridge } from "@multiweb/reactCore/bridge/api";
import { MockBridge } from "../mock";

/**
 * Vytvoří implementaci {@link IBridge} založenou na {@link MockBridge}, kde jsou přepsány metody těmi specifikovanými v overrides.
 * Umožňuje kratší zápis oproti vytváření vlastní rozšiřující třídy.
 * @param overrides Metody, které přepíší výchozí implementaci z MockBridge.
 */
export const createStubBridge = (overrides: Partial<IBridge>): IBridge => {
    const mockInstance = new MockBridge();
    const mock = {
        ...mockInstance,
        module: mockInstance.module, // atributy implementované přes getter se nepřenáší při použití spread operátoru
        ...overrides,
    };

    return mock as IBridge;
};
